import { Link } from 'react-router-dom';
import styles from './traces.module.css';

type Props = {
  traceId: string;
  label?: string;
  className?: string;
};

export function TraceLink({ traceId, label, className }: Props) {
  const short = `${traceId.slice(0, 8)}…`;
  return (
    <Link
      to={`/app/traces/${traceId}`}
      className={[styles.traceLink, className].filter(Boolean).join(' ')}
      title={traceId}
    >
      {label ?? `Trace ${short}`}
    </Link>
  );
}
